import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { height } from '@mui/system';

export const useStyles = makeStyles((theme: Theme) => ({
  alumniSurvey: {
    // // height: 'calc(100vh - 143px)',
    // // width: '100% !important',
    // [theme.breakpoints.down('sm')]: {
    //    height: 'calc(100vh - 100px)',
    //   // height: '100%',
    //   // paddingBottom: '90px',
    // },

  },
  alumniSurveyContainer: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    borderRadius: '9px !important',
    padding: '26px ',
    width: '100%',
    height: 'calc(100vh - 143px)',
    overflowY: 'hidden'

  },
  alumniSurveyContainerMobile: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    borderRadius: '9px !important',
    padding: "16px",
    width: '100%',
    height: '100%',
    [theme.breakpoints.down('sm')]: {
      height: '100% !important'
    },

    // '@media (min-width: 480px) and (max-width: 600px)': {
    //   height: '47vh !important',
    //   padding: "26px 0px 26px 17px"
    // },
  },
  alumniSurveyContainerMobile1: {
    background: theme.palette.KenColors.kenWhite,
    boxShadow: 'none !important',
    borderRadius: '9px !important',
    padding: "26px 0px 26px 17px",
    width: '100%',
    height: 'calc(100vh - 143px)',
         [theme.breakpoints.down('sm')]: {
          height : 'auto'
}



  },
  sectionTitle1: {
    textAlign: 'left',
    fontSize: '16px ',
    fontWeight: '500 !important',
    marginBottom: '10px !important',
  },
  alumniCreateSurveyContainer: {
    boxShadow: 'none !important',
    borderRadius: '16px !important',
    width: '100%',
    height: '60%',
  },
  alumniCreateSurveyContainerTitle: {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    textAlign: 'start',
    [theme.breakpoints.down('md')]: {
      fontSize: '16px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12px !important',
      fontWeight: '600 !important',
    },
  },
  // alumniCreateSurveyContainerTitleBorder: { background: '#373A45', height: '0.8px', marginTop: '4px', marginX: '4px', opacity: 0.5 },
  alumniCreateSurveyContainerBody: { display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', paddingTop: '50px !important' },
  beginSurveyImg: {
    marginTop: '32px',
    userSelect: 'none',
    '@media (min-width: 280px) and (max-width: 600px)': {
      height: '92.36px !important',
      width: '100.45px !important',
    },
  },
  alumniCreateSurveyContainerBodyTitle: {
    fontSize: '15px !important',
    fontWeight: '500 !important',
    [theme.breakpoints.down('md')]: {
      fontSize: '16px !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '13px !important',
    },
  },
  alumniCreateSurveyContainerBodyDescription: {
    fontSize: '12px !important',
    fontWeight: '400 !important',
    paddingInline: '50px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '10px !important',
    },
  },
  beginSurveyButton: {
    fontSize: '16px !important',
    fontWeight: '600 !important',
    color: '#5B4200 !important',
    marginTop: '25px !important',
    boxShadow: 'none !important',
    borderRadius: '8px !important',
    background: 'var(--Gradient, linear-gradient(90deg,#F7A703,#FFE090)) !important',
    padding: '20px !important',
    height: '36px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '28px !important',
    },
  },
  beginSurveyButton1: {
    fontSize: '16px !important',
    fontWeight: '600 !important',
    color: '#5B4200 !important',
    boxShadow: 'none !important',
    borderRadius: '8px !important',
    background: 'var(--Gradient,linear-gradient(90deg,#F7A703,#FFE090)) !important',
    padding: '20px !important',
    height: '36px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '20px !important',
      padding: '10px !important',
    },
    '@media (min-width: 280px) and (max-width: 600px)': {
      padding: '10px !important',
    },
  },

  //   create survey styles
  formFooter: {
    display: 'flex',
    justifyContent: 'end',
    gap: '20px',
    borderTop: `1px solid ${theme.palette.KenColors.ClientDivider}`,
    paddingTop: '20px',
    marginTop: 'auto',
    backgroundColor: theme.palette.KenColors.kenWhite,
    position: 'sticky',
    bottom: 0,
    paddingBottom: '12px',
    zIndex: 1,
  },
  cardContainerForm: {
    boxShadow: 'none !important',
    textAlign: 'start',
    borderRadius: '9px !important',
    padding: '20px',
    height: 'calc(100vh - 143px)',
    display: 'flex',
    flexDirection: 'column',
    [theme.breakpoints.down('md')]: {
      height: 'calc(100vh - 100px)',
    },
  },
  pageHeader: {
    fontSize: '16px !important',
    fontWeight: '550 !important',
    color: theme.palette.KenColors.ClientBlack2,
    padding: '10px 0px 10px 0px !important',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      fontSize: '12px !important',
    },
  },
  gridContainer: {
    height: '100%',
    paddingBottom : '16px',
    overflowX: 'hidden',
    overflowY: 'auto',
    '@media (min-width: 1270px) and (max-width: 1290px)': {
      height: '58vh !important',
    },
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '54vh !important',
    },

  },

  // SurveyDialog
  profileButton: {
    display: 'flex !important',
    borderRadius: '6px !important',
    boxShadow: 'none !important',
  },
  dilogHeader: {
    fontSize: '20px !important',
    fontWeight: '500 !important',
    marginBottom: '12px !important',
    borderBottom: '2px solid #BFCEFF',
    paddingBottom: '10px',
  },
  dilogtypo: {
    fontSize: '16px !important',
    fontWeight: '500 !important',
    marginBottom: '8px !important',
  },
  customSelect: {
    '& .MuiOutlinedInput-notchedOutline': {
      border: '0.5px solid #B2B3B7 !important',
      padding: '0px 12px !important',
      borderRadius: '12px !important',
    },
    '& .css-11u53oe-MuiSelect-select-MuiInputBase-input-MuiOutlinedInput-input.MuiSelect-select': {
      padding: '10px !important',
    },
  },
  customTextArea: {
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      border: '0.5px solid #B2B3B7 !important',
      padding: '10px 12px !important',
      borderRadius: '12px !important',
      textAlign: 'center !important',
    },
  },
  customText: {
    '& .MuiInputBase-root.MuiOutlinedInput-root': {
      border: '0.5px solid #B2B3B7 !important',
      padding: '0px 12px !important',
      borderRadius: '12px !important',
      textAlign: 'center !important',
    },
    '& .MuiInputBase-input.MuiOutlinedInput-input': {
      padding: '10px !important',
    },
  },
  alumiBox: {
    height: '100%',
    overflowY: 'auto',
    [theme.breakpoints.down('sm')]: {
      height: '100%',
    },
  },
  alumiBox2: {
    height: '75vh',
    [theme.breakpoints.up('xxl')]: {
      height: '68vh',
    },
  },
  alumiBox1: {
    height: '65vh',
    [theme.breakpoints.up('xxl')]: {
      height: '72vh',
    },
    '@media (min-width: 1536px) and (max-width: 1600px)': {
      height: '75vh',
    },
    '@media (min-width: 336px) and (max-width: 600px)': {
      height: '50vh',
    },
  },
  horizontalLine: {
    height: '58vh',
    backgroundColor: '#E5E6EA',
    width: '1px',
    '@media (min-width: 1280px) and (max-width: 1300px)': {
      height: '54vh !important',
    },
  },
}));
